<template>
    <ion-icon name="checkmark-circle" class="success" :style="styles" ref="icon" v-if="actualType === statuses.STATUS_SUCCESS"></ion-icon>
    <ion-icon name="warning" class="warning" :style="styles" ref="icon" v-else-if="actualType === statuses.STATUS_WARNING"></ion-icon>
    <ion-icon name="close-circle" class="fail" :style="styles" ref="icon" v-else-if="actualType === statuses.STATUS_FAIL"></ion-icon>
    <ion-icon name="remove-circle" class="cancel" :style="styles" ref="icon" v-else-if="actualType === statuses.STATUS_CANCEL"></ion-icon>
    <img :style="styles" ref="icon" :src="spinner" v-else-if="actualType === statuses.STATUS_LOADING">
</template>

<script>
    import Spinner from '../../../public/static/images/supernova_spinner.svg'

    export const statuses = {
        STATUS_SUCCESS: 'success',
        STATUS_FAIL: 'fail',
        STATUS_WARNING: 'warning',
        STATUS_CANCEL: 'cancel',
        STATUS_LOADING: 'loading',
    };

    export default {
        props: {
            type: {
                type: String,
                default: 'success'
            },
            height: {
                type: Number,
                default: 20
            },
            width: {
                type: Number,
                default: 24
            }
        },
        computed: {
            actualType() {
                const allowedTypes = Object.values(statuses);
                return ~allowedTypes.indexOf(this.type)? this.type : statuses.STATUS_SUCCESS;
            },
            styles() {
                return 'width: ' + this.width + 'px' + ';height:' + this.height + 'px' + ';';
            },
            spinner() {
                return Spinner;
            },
            statuses() {
                return statuses;
            }
        },
    }
</script>

<style scoped lang="scss">
    @import '../../sass/_variables.scss';

    .warning {
        color: $warning-background-color;
    }

    .success {
        color: $success-background-color;
    }

    .fail {
        color: $error-background-color;
    }

    .cancel {
        color: $cancel-background-color;
    }

    ion-icon, img {
        display: inline-block;
    }
</style>
